<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">{{ groupId ? 'Edit' : 'Add' }} Contact Group</span>
    </div>
    <div class="d-flex justify-content-center align-items-center pt-35-px" v-if="isLoading">
      <Spinner />
    </div>
    <ContactGroupForm v-if="!isLoading" :description="description" @submit="onSubmit($event)">
      <template slot="contacts">
        <label>Contacts</label>
        <PaginationTable
          :pagination="pagin"
          :columns="ContactListColumn"
          :dataSource="contacts"
          :tableSize="tableSize"
        >
          <template slot="operation" slot-scope="{ record }">
            <a-dropdown placement="topLeft">
              <a-icon class="operation" type="ellipsis" />
              <a-menu slot="overlay" class="operation-menu">
                <a-menu-item>
                  <router-link
                    class="nav-link"
                    :to="{ path: `/contact/${record.id}`}"
                  >
                    <a-icon type="edit"></a-icon>
                    Edit
                  </router-link>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </template>
        </PaginationTable>
      </template>
      <template slot="contacts-table-footer">
        <PaginationBar :pageSize.sync="pagin.pageSize" :total="pagin.total" @change="paginChange" />
      </template>
    </ContactGroupForm>
  </div>
</template>

<script>
  import ContactGroupService from '../services/contact-group.service';
  import ContactGroupForm from './ContactGroupForm';
  import { ContactListColumn } from "../helper.js";

  export default {
    name: 'ContactEdit',
    components: {
      ContactGroupForm
    },
    data() {
      let pageSize = Number(window.localStorage.getItem("pageSize"));
      if(!pageSize)
       pageSize = 5;

      return {
        groupId: this.$route.params.group,
        description: '',
        isLoading: true,
        contacts: [],
        ContactListColumn,
        pagin: {
          current: 1,
          pageSize: pageSize,
          total: 0
        },
        tableSize: {
          height: '',
          width: ''
        },
      };
    },
    mounted() {
      this.getContactGroup();
    },
    methods: {
      async onSubmit(event) {
        try {
          await ContactGroupService.update(this.groupId, event);
          this.$showSuccessMessage('Updated Contact group');
          this.$router.push('/contact-group/list');
        } catch (error) {
          this.$showMultiErrorMessage(error.messages);
        }
      },
      async getContactGroup() {
        try {
          const { description, contacts } = await ContactGroupService.get(this.groupId);
          this.description = description;
          this.contacts = [...(contacts || [])].map((item, index) => {
            item.index = index + 1;
            return item;
          })
          this.pagin.total = contacts.length;
        } catch (error) {
          this.$showMultiErrorMessage(error.messages);
        } finally {
          this.isLoading = false;
        }
      },
      paginChange(pagin) {
        this.pagin = { ...pagin };
      }
    }
  };
</script>

<style lang="scss" scoped></style>
